import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function DisclaimerPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <section className="pt-20 md:pt-24 pb-8 md:pb-12 bg-background-100">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center gap-2 mb-4">
              <a href="/" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors flex items-center gap-1">
                <i className="ri-home-line w-3 h-3 flex items-center justify-center" /> Home
              </a>
              <span className="text-foreground-300">/</span>
              <span className="text-xs text-primary-600 font-medium">Disclaimer</span>
            </div>
            <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4 leading-tight">
              <span className="text-primary-500">Disclaimer</span>
            </h1>
          </div>
        </div>
      </section>

      <section className="w-full py-12 md:py-16">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-xl border border-background-200 p-6 md:p-8 lg:p-10">
              <div className="prose prose-sm max-w-none text-foreground-600 leading-relaxed">
                <p className="mb-4">
                  The information provided on CSSBuyBR.info is for general informational and educational purposes only. By using this website, you acknowledge and agree to the following terms:
                </p>
                <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mt-8 mb-4">Independent Resource</h2>
                <p className="mb-4">
                  CSSBuyBR.info is an independent informational resource and is not the official CSSBuy website. We are not affiliated with, endorsed by, or connected to CSSBuy in any way. We do not process payments, sell products, or provide buying agent services.
                </p>
                <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mt-8 mb-4">No Liability</h2>
                <p className="mb-4">
                  We make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, or suitability of the information on this website. Any reliance you place on such information is strictly at your own risk.
                </p>
                <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mt-8 mb-4">Verify Official Information</h2>
                <p className="mb-4">
                  Always verify important account, payment, shipping, and policy information through the official CSSBuy channels before taking any action. Information on this website may become outdated, and policies may change without notice.
                </p>
                <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mt-8 mb-4">External Links</h2>
                <p className="mb-4">
                  This website contains links to external websites. We are not responsible for the content, privacy policies, or practices of any third-party websites. Visiting external links is at your own discretion and risk.
                </p>
                <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mt-8 mb-4">No Professional Advice</h2>
                <p className="mb-4">
                  The content on this website does not constitute professional, legal, financial, or purchasing advice. For specific guidance related to your situation, please consult with appropriate professionals or the official CSSBuy support team.
                </p>
                <div className="p-4 bg-amber-50 border border-amber-200 rounded-lg mt-8">
                  <p className="text-sm text-amber-800">
                    If you have any questions about this disclaimer, please contact us through the appropriate channels. By continuing to use this website, you accept these terms in full.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}